import React, {useEffect, useState} from "react";
import useSerializedRefresh from "../../../useSerializedRefresh";
import ApiService from "../../../../../services/ApiService";

export default function ScreenDonSection({context, campagneData, colors = {}})
{
    const [loading, setLoading] = useState(true)
    const [dons, setDons] = useState([])

    const formater = new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2})

    const screenOptions = campagneData?.screenOptions || {}


    const getDisplayName = (campagneExtraData = {}) => {
        return campagneExtraData?.displayName || "Anonyme"
    }

    const getDons = async () => {
        let url = "/campagne/donors/" + campagneData.id

        const res = await ApiService.get(url)
        let _dons = res.data

        if(screenOptions.minMontant){
            _dons = _dons.filter(i => i.montant >= screenOptions.minMontant)
        }

        setDons(_dons)
        setLoading(false)
    }

    useSerializedRefresh(getDons, campagneData?._liveRevision)


    if(loading){
        return null
    }

    return (
        <div style={{display: "flex", justifyContent: "center", alignItems: "center", padding: "0 5vw"}}>
            <div style={{
                overflow: "visible",
                width: "85%",
                height: "14vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row-reverse",
                gap: "2vw",
            }}>
                {dons.map((d, index) => {

                    let className = "talpiot-don-card"

                    if(index < 3){
                        className += " talpiot-don-fade-in"
                    }else{
                        className += " talpiot-don-fade-out"
                    }

                    // Montant brut (campagne en montant, pas en parrainage : aucune division).
                    const montant = formater.format(d.montant)

                    // Symbole selon la devise réelle du don : shekel -> "NIS", sinon "€".
                    const devise = (d.devise || "").toLowerCase()
                    const symbole = (devise === "ils" || devise === "nis") ? "nis" : "€"

                    return (
                        <div key={d.id} className={className}>
                            <span style={{
                                color: colors.deepBlue || "#0D3867",
                                fontSize: "5vh",
                                lineHeight: 1.1,
                                textAlign: "center",
                                fontFamily: "Talpiot-Playfair",
                                fontStyle: "italic",
                                fontWeight: 600,
                            }}>
                                {montant} {symbole}
                            </span>
                            <span style={{
                                color: colors.deepBlue || "#0D3867",
                                fontSize: "3vh",
                                marginTop: "0.6vh",
                                textAlign: "center",
                                fontFamily: "Talpiot-Proxima",
                                fontWeight: 500,
                                padding: "0 1vw",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "100%",
                            }}>
                                {getDisplayName(d.campagneExtraData)}
                            </span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
